import React, { forwardRef } from 'react';
import type { View, ViewProps } from 'react-native';
import { TableRow } from './TableRow';

type TableHeaderProps = ViewProps & {
  children: React.ReactNode;
};

/**
 * TableHeader - Semantic wrapper for table header rows
 *
 * Just a TableRow with a clear semantic name for header content.
 * Use this to wrap TableHead cells in your table header.
 *
 * @example
 * ```tsx
 * <Table>
 *   <TableHeader>
 *     <TableHead>Name</TableHead>
 *     <TableHead>Email</TableHead>
 *     <TableHead>Role</TableHead>
 *   </TableHeader>
 *   <TableBody>
 *     {data.map(item => (
 *       <TableRow key={item.id}>
 *         <TableCell>{item.name}</TableCell>
 *         <TableCell>{item.email}</TableCell>
 *         <TableCell>{item.role}</TableCell>
 *       </TableRow>
 *     ))}
 *   </TableBody>
 * </Table>
 * ```
 */
export const TableHeader = forwardRef<View, TableHeaderProps>(
  ({ children, ...props }, ref) => {
    return (
      <TableRow ref={ref} {...props}>
        {children}
      </TableRow>
    );
  },
);

TableHeader.displayName = 'TableHeader';
